import { render, staticRenderFns } from "./MenuCartCallWaiterModal.vue?vue&type=template&id=797a710c&"
var script = {}
import style0 from "./MenuCartCallWaiterModal.vue?vue&type=style&index=0&id=797a710c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports